import { render, staticRenderFns } from "./tab-pane-container-minimal.vue?vue&type=template&id=6be76a57&"
import script from "./tab-pane-container-minimal.vue?vue&type=script&lang=js&"
export * from "./tab-pane-container-minimal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports